import React, { useEffect, useState } from "react";
import { Heart, Send, MessageSquare } from "lucide-react";
import api from "../lib/api";
import { PageHeader, Card, Avatar, Loading, fmtDate, EmptyState } from "../components/ui";

export default function Vibe() {
  const [posts, setPosts] = useState(null);
  const [content, setContent] = useState("");
  const load = () => api.get("/vibe").then(({ data }) => setPosts(data));
  useEffect(() => { load(); }, []);
  const post = async (e) => { e.preventDefault(); if (!content.trim()) return; await api.post("/vibe", { content }); setContent(""); load(); };
  const like = async (id) => { await api.post(`/vibe/${id}/like`); load(); };
  if (!posts) return <Loading />;

  return (
    <div className="mx-auto max-w-2xl">
      <PageHeader title="Vibe" subtitle="What's happening at SMIFS" />
      <Card className="mb-6 p-5">
        <form onSubmit={post} className="flex gap-3">
          <input data-testid="vibe-input" value={content} onChange={(e) => setContent(e.target.value)} placeholder="Share something with your team…" className="input flex-1" />
          <button type="submit" data-testid="vibe-post" className="btn-accent"><Send size={16} /></button>
        </form>
      </Card>
      {posts.length === 0 ? <EmptyState icon={MessageSquare} title="No posts yet" /> : (
        <div className="space-y-4">
          {posts.map((p) => (
            <Card key={p.id} className="p-5" data-testid={`vibe-${p.id}`}>
              <div className="flex items-center gap-3">
                <Avatar name={p.authorName} size={40} />
                <div><p className="text-sm font-semibold text-slate-800 dark:text-slate-100">{p.authorName}</p><p className="text-xs text-slate-400">{fmtDate(p.createdAt)}</p></div>
              </div>
              <p className="mt-3 text-sm text-slate-700 dark:text-slate-200">{p.content}</p>
              <div className="mt-4 flex items-center gap-4 border-t border-slate-100 pt-3 dark:border-slate-800">
                <button onClick={() => like(p.id)} data-testid={`like-${p.id}`} className={`flex items-center gap-1.5 text-sm ${p.liked ? "text-red-500" : "text-slate-400 hover:text-red-500"}`}>
                  <Heart size={16} fill={p.liked ? "currentColor" : "none"} /> {p.likeCount}
                </button>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
